import React, { useEffect } from 'react'
import { scrollToTop } from './HelperFunctions';
import { UnitsOfMeasure } from "./Constants";

export const CartSummary = ({ cartSummaryUoms, setCartSummaryUoms, updateCart }) => {
    const cartSummaryItems = [];
    const cartSummaryTmp = cartSummaryUoms;

    useEffect(() => {
        let summaryChanged = false;
        updateCart?.ItemList.forEach(item => {
            item.UoMPrices.forEach(uom => {
                if (uom.MessageCode === 'Success') {
                    const index = cartSummaryUoms.findIndex(summaryUom => summaryUom.ItemID === uom.ItemID && summaryUom.UMQty === uom.UMQty);
                    uom.SDname = item.SDname;
                    uom.VendItemNo = item.VendItemNo;
                    if (index === -1) cartSummaryTmp.push(uom);
                    else {
                        if (uom.QtyOrdered === 0) cartSummaryTmp.splice(index, 1);
                        else cartSummaryTmp[index] = uom;
                    }
                    summaryChanged = true;
                }
            })
        })
        if (summaryChanged) scrollToTop();
        setCartSummaryUoms([...cartSummaryTmp]);
    }, [updateCart])

    if (!!cartSummaryUoms.length) {
        cartSummaryUoms.forEach(uom => {
            const [description, size] = uom.SDname.split(',');
            cartSummaryItems.push(window.outerWidth >= 992
                ? <tr className="tw-text-[17px]" style={{ border: "2px solid #C8C8C8" }}>
                    <td className="tw-pl-[16px] tw-flex tw-gap-[14px] tw-py-[5px]">
                        <img className="tw-w-[21px]" src="/Content/img/sprites/instock-alert.svg" />
                        <span>{`${!!description ? description : 'Description N/A'} | MFG#: ${uom.VendItemNo}`}</span>
                    </td>
                    <td><span className="tw-font-bold">Description:</span> {!!size ? size : 'N/A'}</td>
                    <td><span className="tw-font-bold">UoM:&nbsp;</span>
                        {!UnitsOfMeasure[uom.UMDesc]
                            ? `${uom.UMDesc} of ${uom.UMQty} each`
                            : uom.UMDesc !== 'ea'
                                ? `${UnitsOfMeasure[uom.UMDesc]} of ${uom.UMQty} each`
                                : 'Single'
                        }
                    </td>
                    <td><span className="tw-font-bold">Quantity:</span> {uom.QtyOrdered}</td>
                    <td className="tw-hidden xxl:tw-block"></td>
                </tr>
                : <>
                    <div className="tw-flex tw-gap-[14px] tw-w-full">
                        <img className="tw-w-[21px] tw-mt-[4px] tw-self-start" src="/Content/img/sprites/instock-alert.svg" />
                        <div className="tw-flex tw-flex-col">
                            <span className="tw-text-[16px]">{`${!!description ? description : 'Description N/A'} | MFG#: ${uom.VendItemNo}`}</span>
                            <div>
                                <span className="tw-font-bold tw-text-[13px]">Description:</span> {!!size ? size : 'N/A'}
                                &nbsp;|&nbsp;
                                <span className="tw-font-bold tw-text-[13px]">UoM:&nbsp;</span>
                                {!UnitsOfMeasure[uom.UMDesc]
                                    ? `${uom.UMDesc} of ${uom.UMQty} each`
                                    : uom.UMDesc !== 'ea'
                                        ? `${UnitsOfMeasure[uom.UMDesc]} of ${uom.UMQty} each`
                                        : 'Single'}
                            </div>
                        </div>
                    </div>
                    <div className="tw-pl-[10px] tw-content-around" style={{ borderLeft: "1px solid #282828" }}>
                        <div className="tw-text-[13px]">QTY</div> <div className="tw-text-[20px]">{uom.QtyOrdered}</div>
                    </div>
                </>
            )
        })
    }

    return (
        !!cartSummaryItems.length && <>
            <div className="tw-flex tw-justify-between tw-items-end">
                <div className="tw-font-bold tk-trade-gothic-next-condensed tw-ml-[18px] tw-mb-[4px] tw-text-[22px] tw-mt-[8px]">Items Added To Cart</div>
                <div className="close tw-opacity-100 tw-cursor-pointer" onClick={() => setCartSummaryUoms([])}>
                    <img src="/Content/img/sprites/close-btn.svg" alt="Close" className="tw-w-[29px] tw-mb-[-2px]" />
                </div>
            </div>
            {window.outerWidth >= 992
                ? <table className="tw-mb-[50px] tw-bg-[#F6F6F6]" style={{ border: "2px solid #C8C8C8" }}>
                    <colgroup>
                        <col span="1" className="tw-w-[36%]" />
                        <col span="1" className="tw-w-[13%]" />
                        <col span="1" className="tw-w-[19%]" />
                        <col span="1" className="tw-w-[10%]" />
                        <col span="1" className="tw-w-[25%] tw-hidden xxl:tw-block" />
                    </colgroup>
                    <tbody>
                        {cartSummaryItems}
                        <tr style={{ borderTop: "2px solid #C8C8C8" }}>
                            <td className="tw-pl-[16px] tw-py-[9px]">
                                <div onClick={() => window.open('/ShoppingCart', '_self')}
                                    className="tw-cursor-pointer tw-w-[100%] sm:tw-w-[174px] tw-h-[35px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px]">
                                    View Cart
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                : <>
                    {cartSummaryItems.map((item, i) => {
                        return (
                            <div className={"tw-flex tw-py-[10px] tw-pl-[16px] tw-pr-[16px] md:tw-pr-[150px] tw-bg-[#F6F6F6] tw-border-[0px] tw-border-x-[2px] tw-border-b-[2px] tw-border-solid tw-border-x-[#c8c8c8] tw-border-b-[#c8c8c8] "
                                + (i === 0 ? "tw-border-t-[2px] tw-border-t-[#c8c8c8]" : "")}>
                                {item}
                            </div>
                        )
                    })}
                    <div className="tw-py-[9px] tw-self-center tw-border-t-[0px] tw-w-full tw-bg-[#F6F6F6] tw-text-center" style={{ border: "2px solid #c8c8c8" }}>
                        <div onClick={() => window.open('/ShoppingCart', '_self')}
                            className="tw-cursor-pointer tw-w-[174px] tw-h-[35px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px]">
                            View Cart
                        </div>
                    </div>
                </>
            }
        </>
    )
}